import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { ROOT_PATH as AUTH_ROUTES } from 'routes/authRoutes';
import queryString from 'query-string';
import { VALID_AUTH_REGIONS } from 'views/pages/Auth/constants';
import { setRegion } from 'common/localStorageUtils';

function ResetPasswordEmailLink(props) {
  const {
    location,
    match: { params },
  } = props;
  const qs = queryString.parse(location.search);
  if (qs.region && Object.values(VALID_AUTH_REGIONS).includes(qs.region)) {
    setRegion(qs.region);
  }
  return <Redirect to={`${AUTH_ROUTES.RESET_PASSWORD}/${params.token}`} />;
}

export default withRouter(ResetPasswordEmailLink);



// WEBPACK FOOTER //
// ./src/views/pages/Auth/ResetPasswordEmailLink.jsx